import {useParams} from "react-router-dom";

import React, {Suspense, useEffect} from "react";
import ErrPage from "../../../../Common/pages/ErrPage";
import LoadingContainer from "../../../../Common/component/LoadingContainer/LoadingContainer";

//import DemoLogin from "../../../../Docuwiz-service/Demo/login/Login";
//import DefaultLogin from "../../../../Docuwiz-service/Default/login/Login";
//import PostechLogin from "../../../../Docuwiz-service/Postech/login/Login";
//import BusanpaLogin from "../../../../Docuwiz-service/Busanpa/login/Login";

const LoginPage = () =>
{
    const { param } = useParams() as { param: string };
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const ComponentLogin = React.lazy(()=>import(`../../../../Docuwiz-service/Customer/${serviceCode}/login/Login`))


    useEffect(() => {
        // data 상태가 변경될 때마다 현재 창에 포커스를 설정합니다.
        window.focus();
    }, []);

    /*
    switch (serviceCode) {
        case 'DEFAULT':
            return <DefaultLogin param={param} serviceCode={`${serviceCode}LI`} />;
        case 'DEMO':
            return <DemoLogin param={param} serviceCode={`${serviceCode}LI`} />;
        case 'POSTECH':
            return <PostechLogin param={param} serviceCode={`${serviceCode}LI`} />;
        case 'BUSANPA':
            return <BusanpaLogin param={param} serviceCode={`${serviceCode}LI`} />;
        default:
            return <ErrPage errCode={9999} />;
    }

     */

return ComponentLogin ?    <Suspense fallback={<LoadingContainer message="Loading Modules.." />}>
                            <ComponentLogin param={param} serviceCode={`${serviceCode}LI`} />
                        </Suspense>
                        : <ErrPage errCode={9999} />;

}
export default LoginPage;